// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1K4se","title":"styles_title__2Qh5k"};